import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios, {all} from "axios";
import config from "../config";
import Select from "../sections/MUI/Select";
import Field from "../sections/MUI/Field";
import jMoment from "jalali-moment";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import {toast} from "react-toastify";

class CreateOrder extends Component {

    state = {
        regions: [],
        services: [],
        users: [],

        region: "",
        service: "",
        time: "1",
        date: jMoment().format("jYYYY/jMM/jDD"),
        mTime: jMoment().add(1, "hour").format("HH:00"),
        options: [],
        gadgets: [],
        address: "",
        tel: "",
        description: "",
        user: "",
        food: "true",
        niroo: "1",

        userModal: false
    };


    componentDidMount() {
        this.getRegions();
        this.getServices()
        this.getUsers();
    }

    getUsers() {
        axios.get(`${config.api}/admin/order/users?token=${config.token}`)
            .then(r => {
                this.setState({
                    users: r.data.result
                });
            })
            .catch(err => {
            });
    }

    getRegions() {
        axios.get(`${config.api}/admin/region?token=${config.token}`)
            .then(r => {
                this.setState({
                    regions: r.data.result
                });
            })
            .catch(err => {

            });
    }

    getServices() {
        axios.get(`${config.api}/admin/service?token=${config.token}`)
            .then(r => {
                this.setState({services: r.data.result});
            })
            .catch(err => {

            });
    }

    getOptionsAndGadgets(service) {
        const {services} = this.state;
        let options = [];
        let gadgets = [];
        services.map(s => {
            if (s.id === service) {
                options = s.options;
                gadgets = s.gadgets;
            }
        });
        return {
            options,
            gadgets
        }
    }

    submit() {
        const {
            region,
            service,
            time,
            date,
            mTime,
            options,
            gadgets,
            address,
            tel,
            description,
            user,
            food,
            niroo
        } = this.state;
        if (user !== "") {
            let params = new URLSearchParams();
            params.append("description", description);
            params.append("service", service);
            params.append("region", region);
            params.append("options", JSON.stringify(options));
            params.append("gadgets", JSON.stringify(gadgets));
            params.append("time", time);
            params.append("dateTime", date + " " + mTime);
            params.append("address", address);
            params.append("tel", tel);
            params.append("user", user);
            params.append("food", food);
            params.append("niroo", niroo);
            toast.info("در حال ثبت ...")
            axios.post(`${config.api}/admin/order?token=${config.token}`, params)
                .then(r => {
                    toast.success("با موفقیت ثبت شد");
                })
                .catch(err => {

                });

        } else {
            toast.error("مشتری انتخاب نشده است.")
        }

    }

    render() {
        const {
            services, regions, users,
            region, service, time, date, mTime, options, gadgets, address, tel, description, user, food, niroo,
            userModal
        } = this.state;
        return (
            <div className="create-order">
                {
                    userModal ?
                        <Modal display={userModal}
                               title="انتخاب مشتری"
                               onCloseClick={() => this.setState({userModal: false})}
                               icon="user">

                            <div className="modal-select-user">
                                {
                                    users.map((u, i) =>
                                        <article key={"user" + i} className={u.id === user ? "active" : ""}
                                                 onClick={() => this.setState({
                                                     user: u.id,
                                                     userModal: false
                                                 })}>
                                            <span className="code">#{u.code}</span>
                                            <div className="full-name">
                                                <span>{u.firstName}&nbsp;{u.lastName}</span>&nbsp;
                                                <span>({u.phoneNumber})</span></div>
                                        </article>
                                    )
                                }
                            </div>
                        </Modal>
                        : null
                }

                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} onClick={() => this.setState({userModal: true})}>انتخاب مشتری</Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Select value={region}
                                name="region"
                                label="محله"
                                simple
                                placeholder="انتخاب محله"
                                options={regions.map((r, i) => {
                                    return {t: r.title, v: r.id}
                                })}
                                onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <Select value={service}
                                name="service"
                                label="خدمت"
                                simple
                                placeholder="انتخاب خدمت"
                                options={services.map((s, i) => {
                                    return {t: s.title, v: s.id}
                                })}
                                onChange={(name, value) => {
                                    this.setState({
                                        [name]: value,
                                        options: this.getOptionsAndGadgets(value).options.map(o => {
                                            return {
                                                t: o, v: ""
                                            }
                                        })
                                    });

                                }}/>
                    </div>
                    <div className="col-md-4">
                        <Field name="time"
                               value={time}
                               type="number"
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.setState({[name]: value})}
                               label="تعداد ساعت"/>
                    </div>
                    <div className="col-md-4">
                        <Field name="date"
                               value={date}
                               type="text"
                               onChange={(name, value) => this.setState({[name]: value})}
                               label="تاریخ"/>
                    </div>
                    <div className="col-md-4">
                        <Field name="mTime"
                               value={mTime}
                               type="text"
                               onChange={(name, value) => this.setState({[name]: value})}
                               label="ساعت"/>
                    </div>
                </div>
                <div className="options">
                    <article>
                        <Field name="niroo"
                               value={niroo}
                               maxLength={2}
                               style={{direction: "ltr"}}
                               label="به چند متخصص برای انجام کار نیاز دارید؟"
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </article>
                    {options.map((o, i) =>
                        <article key={"opt" + i}>
                            <Field label={o.t}
                                   name="option"
                                   value={o.v}
                                   onChange={(name, value) => {
                                       let mOptions = options;
                                       mOptions[i].v = value;
                                       this.setState({options: mOptions});
                                   }}/>
                        </article>
                    )}
                </div>
                <div className="gadgets">
                    {this.getOptionsAndGadgets(service).gadgets.map((g, i) =>
                        <article className={gadgets.includes(g) ? "active" : ""}
                                 key={"gad" + i}
                                 onClick={() => {
                                     let mGadgets = gadgets;
                                     let index = -1;
                                     mGadgets.map((mg, i2) => {
                                         if (mg === g) {
                                             index = i2
                                         }
                                     })
                                     if (index !== -1) {
                                         mGadgets.splice(index, 1);
                                     } else {
                                         mGadgets.push(g);
                                     }


                                     this.setState({gadgets: mGadgets})
                                 }}>{g}</article>
                    )}
                </div>
                <Field name="address"
                       type="textarea"
                       value={address}
                       row={3}
                       onChange={(name, value) => this.setState({[name]: value})}
                       label="آدرس"/>
                <Field name="tel"
                       type="number"
                       value={tel}
                       style={{direction: "ltr"}}
                       onChange={(name, value) => this.setState({[name]: value})}
                       label="تلفن"/>

                <Field name="description"
                       type="textarea"
                       value={description}
                       row={3}
                       onChange={(name, value) => this.setState({[name]: value})}
                       label="توضیحات"/>

                <Select value={food}
                        name="food"
                        label="غذا با چه کسی است؟"
                        options={[
                            {t: "غذا با شرکت است", v: "true"},
                            {t: "غذا با کارفرما است", v: "false"}
                        ]}
                        onChange={(name, value) => this.setState({[name]: value})}/>
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <Button submit={false} icon="check" onClick={() => this.submit()}>ثبت کردن</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(CreateOrder);